import { VasProduct } from '@telialt/models/src/EshopModel';
import { selectPossibleRatePlans, selectRatePlanCode } from '@telialt/utils/src/eshopSelectors';

import { useCartQuery } from '../../hooks/queries/useCartQuery';

export const useRatePlanVas = (): VasProduct[] => {
    const { cart } = useCartQuery();
    const ratePlanCodeInCart = selectRatePlanCode(cart);
    const possibleRatePlans = selectPossibleRatePlans(cart);

    const selectedPlan =
        possibleRatePlans?.find((r) => ratePlanCodeInCart != null && r.code === ratePlanCodeInCart) ||
        possibleRatePlans?.[0];

    return selectedPlan?.vasProducts;
};
